var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCitedPaperPuddle = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63 68",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.173 51.873C44.471 66.29 23.531 68.607 11.27 60.888c-2.12-1.336-7.926-5.554-10.206-12.954-2.387-7.748-.733-18.47 4.714-24.286 1.855-1.98 4.228-3.476 4.612-6.522.302-2.415-.746-5.021.86-7.67.255-.4.546-.778.869-1.128 8.943-9.622 37.336-8.343 46.88 9.844 5.862 11.167 2.651 24.976-3.826 33.701z",
    fill: "#CADDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.685 7.87h26.689L51.66 20.434v39.697H12.685V7.869z",
    fill: "#194BB0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.66 20.27L39.26 7.87v12.4H51.66z",
    fill: "#B29A43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.161 37.422c0 .765-.312 1.434-.936 2.008a3.076 3.076 0 01-2.177.86c-1.32 0-2.333-.436-3.04-1.309-.709-.872-1.062-2.078-1.062-3.62 0-1.433.605-2.879 1.817-4.337a11.968 11.968 0 014.408-3.315l.792 1.272c-1.355.657-2.417 1.422-3.185 2.294-.767.873-1.211 1.93-1.331 3.172h1.007c.744 0 1.35.084 1.818.251.468.168.845.4 1.133.7.276.286.468.603.576.95.12.346.18.704.18 1.074zm9.236 0c0 .765-.311 1.434-.935 2.008a3.076 3.076 0 01-2.178.86c-1.32 0-2.333-.436-3.04-1.309-.708-.872-1.062-2.078-1.062-3.62 0-1.433.606-2.879 1.817-4.337a11.968 11.968 0 014.409-3.315l.791 1.272c-1.355.657-2.417 1.422-3.184 2.294-.768.873-1.212 1.93-1.332 3.172h1.008c.743 0 1.35.084 1.817.251.468.168.846.4 1.134.7.275.286.467.603.575.95.12.346.18.704.18 1.074z",
    fill: "#fff"
  })));
};
export default SvgCitedPaperPuddle;